export { default } from './ProviderSocialLinksMobile';
